export const RECIPIENT_SELECTOR_TEST_ID = 'global-bill-recipient-selector';
